<template>
  <v-dialog v-model="show" max-width="500px" persistent>
    <v-card class="modal-card">
      <v-card-title class="background-image" style="font-size: 15px;">
        Conta Google Não Registada<v-spacer></v-spacer>
        <v-btn icon color="red" @click="closeModal" v-if="!redirecting">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text style="padding-top: 1rem;" v-if="!redirecting">
        <p>Para continuar precisa de se registar na nossa plataforma.</p>
        <p>Deseja criar uma conta com o seu login da google? </p>
        <p>Ao registar-se aceita os nossos 
          <button class="link-button" @click="terms = true;">termos e condições </button> e 
          <button class="link-button" @click="openPolicy">política de privacidade</button>
        </p>
      </v-card-text>
      <v-card-text style="padding-top: 1rem;" v-else>
        <div class="d-flex flex-column align-center justify-center text-center">
          <v-progress-circular
            indeterminate
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <p>Aguarde um momento. Estamos a terminar de configurar a sua conta!</p>
        </div>
      </v-card-text>
      <v-card-actions v-if="!redirecting">
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="closeModal">Não</v-btn>
        <v-btn color="primary" @click="registerGoogleLogin">Sim</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import User from "@/api/User.js"

export default {
  props:{
    googleUser: Object,
  },
  data(){
      return{
        redirecting: false,
        show: true
      }
  },
  methods: {
    closeModal() {
      this.$emit("close", false); // Fecha a modal
    },
    async registerGoogleLogin() {      
      this.redirecting = true
      const data = {
        api: "google",
        name: this.googleUser.name,
        token: this.googleUser.token,
        email: this.googleUser.email,
        to_create: true,
      };

      await User.googleLogin(data);


      // Aguarda 1 segundo antes de continuar (para evitar conflitos de destruição)
      await new Promise(resolve => setTimeout(resolve, 2000));


      await User.getSession(false).then(async ({data})  =>  {
        this.$root.session = await User.getInstance(data);
        localStorage['auth'] = 1;
      })
      
      

      this.$emit('register')
    }
  }
};
</script>

<style scoped>
.link-button {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: #1976d2; /* azul ou a cor que preferires */
  cursor: pointer;
  text-decoration: underline;
}

.modal-card {
  border-radius: 12px;
}

.v-card-title {
  font-weight: bold;
  font-size: 18px;
  color: #333;
}

.v-card-text {
  font-size: 16px;
  color: #444;
}
</style>